export default __webpack_public_path__ + "static/media/goshen61.44a7fe5d.jpg";